export class RequestAbortError extends Error {
    constructor(message = "The operation was aborted.") {
        super(message);
        this.name = "AbortError";
    }
}
